export default {
      id: "oc-res-instance-snapshot-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-instance-snapshot",
      toString: function () {
        return this.url;
      }
    }